module.exports = __webpack_public_path__ + "media/notification.d843e3d7.wav";